import { render, staticRenderFns } from "./DoughnutChartCard.vue?vue&type=template&id=0dfe22c8&scoped=true"
import script from "./DoughnutChartCard.vue?vue&type=script&lang=js"
export * from "./DoughnutChartCard.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChartCard.vue?vue&type=style&index=0&id=0dfe22c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe22c8",
  null
  
)

export default component.exports